import { create } from "zustand";

interface CommandPaletteState {
  selectedIndex: number;
  setSelectedIndex: (updater: number | ((prev: number) => number)) => void;
  reset: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  selectedIndex: 0,
  setSelectedIndex: (updater) =>
    set((state) => ({
      selectedIndex:
        typeof updater === "function" ? updater(state.selectedIndex) : updater,
    })),
  reset: () => set({ selectedIndex: 0 }),
}));
